import React from "react";
import Blog_49 from "../component/Blog_49";
function Blog_49_container() {
  return <Blog_49 />;
}

export default Blog_49_container;
